// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__RiFE3","containerItemsCenter":"Skeleton_containerItemsCenter__2tpdR"};